<div class="bg-gray-200 p-5 flex flex-row justify-between items-center">
  <h1 class="font-bold text-2xl">Order Details @if (order) {
    <span>for :#{{order.orderNo}}</span>
  }</h1>
  <button
    (click)="dialogRef.close({ status: false })"
    class="bg-neutral-700 text-white text-sm px-2 py-1 rounded-full"
    matTooltip="Close dialog"
    >
    X
  </button>
</div>


@if (order) {
  <div class="bg-white rounded-sm shadow-sm p-5 mt-2">
    <div class="flex flex-row justify-between items-start">
      <div>
        <p>
          Order <span class="font-semibold">#{{ order.orderNo }}</span> was
          placed on
          <span class="font-semibold">{{
            order.orderDate | date : "MMM d, y"
          }}</span>
          and is currently in
          <span class="font-semibold">{{ order.orderStatus }}</span>
          state
        </p>
        @if(order.paymentMethod) {
          <p>Payment method: <strong>{{order.paymentMethod}}</strong></p>
        }
        @if(order.deliveryMethod === 'COLLECTION') {
          <p>Collection Point: <strong>{{order.store}}</strong></p>
        }
        @if(order.vatNumber) {
          <p>Vat Number: <strong>{{order.vatNumber}}</strong></p>
        }
      </div>
      <div class="flex flex-col gap-y-1">
        <!-- Download Invoice  -->
        <div>
          <button class="underline font-semibold text-orange-600 cursor-pointer"
            (click)="onInvoiceDownload()"
          >Download Invoice</button>
        </div>
        <!-- Download Invoice  -->
        <!-- Send payment link -->
        @if ( order.orderStatus === 'PENDING') {
          <div>
            <button class="underline font-semibold text-orange-600 cursor-pointer"
              (click)="onSendPaymentLink()"
              >Send payment link
              @if (sendPayLinkProgress) {
                <span class="ml-2">
                  <mat-spinner></mat-spinner>
                </span>
              }
            </button>
          </div>
        }
        <!-- Send payment link -->
        <!-- Update status -->
        @if (data.type === 'EDIT') {
          <div class="mt-4 flex flex-row justify-between">
            <div>
              Order Status:
            </div>
            <div>
              <select [(ngModel)]="order.orderStatus" (ngModelChange)="onStatusUpdate()">
                <option [value]="'PENDING'">PENDING</option>
                <option [value]="'ON HOLD'">ON HOLD</option>
                <option [value]="'PROCESSING'">PROCESSING</option>
              </select>
            </div>
          </div>
        }
        <!-- Update status -->
      </div>
    </div>
    <div class="mt-5">
      <table class="w-full border">
        <thead class="bg-gray-100 rounded-md">
          <tr>
            <th class="p-3">Product</th>
            <th class="p-3">Format</th>
            <th class="p-3">Store</th>
            <th class="p-3 text-right">Unit Price</th>
            <th class="p-3 text-right">Quantity</th>
            <th class="p-3 text-right">Total</th>
          </tr>
        </thead>
        <tbody>
          @for (orderItem of order.OrderItems; track orderItem) {
            <tr
              class="my-2 border-b"
              >
              <td class="p-3">
                {{ orderItem.productName }}
                <div class="text-xs text-neutral-600">
                  {{orderItem.productdterms}}
                </div>
              </td>
              <td class="p-3">{{ onGetFormatFromSKU(orderItem.productSku) }}</td>
              <td class="p-3">
                @if (data.type === 'VIEW') {
                  {{orderItem.store? orderItem.store : '-'}}
                }
                @if (data.type === 'EDIT') {
                  <div class="flex flex-row justify-between gap-x-3">
                    <select
                      [(ngModel)] ="orderItem.store"
                      >
                      <option [value]="'Markstey'">Markstey</option>
                      <option [value]="'Kettering'">Kettering</option>
                    </select>
                    <button class="bg-amber-500 px-2 py-1 rounded-sm" (click)="onUpdateOrder(orderItem)">Update</button>
                  </div>
                }
              </td>
              <td class="p-3 text-right">£{{ orderItem.unitPrice }}</td>
              <td class="p-3 text-right">{{ orderItem.quantity }}</td>
              <td class="p-3 text-right">£{{ orderItem.subTotal }}</td>
            </tr>
          }
        </tbody>
        <tfoot class="bg-gray-100 text-black border-md">
          <tr class="border-b">
            <td colspan="4" class="p-2 font-bold">Subtotal</td>
            <td colspan="2" class="p-2 text-xl font-bold text-right">
              £{{ order.orderAmount }}
            </td>
          </tr>
          @if (order.handleCharge > 0) {
            <tr class="border-b">
              <td colspan="4" class="p-2 font-bold">Handling Free</td>
              <td colspan="2" class="p-2 text-lg font-bold text-right">
                £{{ order.handleCharge }}
              </td>
            </tr>
          }
          @if (order.shipCost > 0) {
            <tr class="border-b">
              <td colspan="4" class="p-2 font-bold">Shipping Cost</td>
              <td colspan="2" class="p-2 text-lg font-bold text-right">
                £{{ order.shipCost }}
                <!-- <span class="text-xs ml-2"
                >via Kerbside Delivery - Zone 6 Surcharge</span
                > -->
              </td>
            </tr>
          }
          <!-- <tr class="border-b" *ngIf="order.paymentMethod">
          <td colspan="3" class="p-2 font-bold">Payment Method</td>
          <td colspan="2" class="p-2 text-sm font-bold">
            {{order.paymentMethod}}
          </td>
        </tr> -->
        @if (order.discAmount > 0) {
          <tr>
            <td colspan="4" class="p-2 font-bold">Discounts</td>
            <td colspan="2" class="p-2 text-lg font-bold text-right">
              -£{{ order.discAmount }}
            </td>
          </tr>
        }
        <tr>
          <td colspan="4" class="p-2 font-bold">Net Total</td>
          <td colspan="2" class="p-2 text-2xl font-bold text-right">
            £{{ order.netAmount }}
            <div class="text-xs ml-2">
              (includes £{{ (order.orderAmount / 6).toFixed(2) }} VAT)
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
  <!-- Customer details -->
  @if (billingAddress) {
    <div class="mt-5">
      <div>
        <span class="font-semibold">Customer Name: </span>
        <span>{{billingAddress.firstName + ' ' + billingAddress.lastName}}</span>
      </div>
      <div class="mt-1">
        <span class="font-semibold">Customer Contact No: </span>
        <span>{{billingAddress.phoneNo}}</span>
      </div>
    </div>
  }
  <!-- Customer details -->
  <div class="mt-5">
    <div class="flex flex-col md:flex-row gap-5">
      @if (billingAddress) {
        <div>
          <h1 class="text-lg font-semibold">Billing Details</h1>
          <div class="flex flex-col text-sm">
            <span>{{ billingAddress.address1 }}</span>
            @if (billingAddress.address2 !== '') {
              <span>{{
                billingAddress.address2
              }}</span>
            }
            <span>{{ billingAddress.city }}</span>
            <span>{{ billingAddress.postCode }}</span>
            <span>{{ billingAddress.phoneNo }}</span>
          </div>
        </div>
      }
      @if (shippingAdress) {
        <div>
          <h1 class="text-lg font-semibold">Shipping Details</h1>
          <div class="flex flex-col text-sm">
            <span>{{ shippingAdress.address1 }}</span>
            @if (shippingAdress.address2 !== '') {
              <span>{{
                shippingAdress.address2
              }}</span>
            }
            <span>{{ shippingAdress.city }}</span>
            <span>{{ shippingAdress.postCode }}</span>
            <span>{{ shippingAdress.phoneNo }}</span>
          </div>
        </div>
      }
      @if (order && order.orderNotes) {
        <div>
          <h1 class="text-lg font-semibold">Customer Notes:</h1>
          <div class="w-full bg-slate-300 text-sm p-5 rounded-sm">
            {{order.orderNotes}}
          </div>
        </div>
      }
    </div>
  </div>
</div>
}
